// src/pages/evenements/assistances/NouvelleAssistance.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../../layouts/Header';
import Footer from '../../../layouts/Footer';
import { COLORS } from '../../../constants/colors';

export default function NouvelleAssistance() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [eglises, setEglises] = useState([]);
  
  const [formData, setFormData] = useState({
    theme: '',
    type: '',
    orateur: '',
    nb_homme: '',
    nb_femme: '',
    nb_enfant: '',
    date_at: new Date().toISOString().split('T')[0],
    matri_eglise: ''
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }

        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;
        
        // Récupérer les églises
        const response = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&type=siege&limit=1000`);
        const result = await response.json();
        
        if (result.success) {
          setEglises(result.eglises || []);
        }

        // Si modification, charger les données
        if (id) {
          const assistanceRes = await fetch(`https://josephsbusiness.com/api/assistances.php?user_id=${userId}&id=${id}`);
          const assistanceData = await assistanceRes.json();
          if (assistanceData.success && assistanceData.assistance) {
            const assistance = assistanceData.assistance;
            setFormData({
              theme: assistance.theme,
              type: assistance.type,
              orateur: assistance.orateur,
              nb_homme: assistance.nb_homme,
              nb_femme: assistance.nb_femme,
              nb_enfant: assistance.nb_enfant,
              date_at: assistance.date_at,
              matri_eglise: assistance.matri_eglise
            });
          }
        }
      } catch (err) {
        setError('Erreur de chargement: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.theme) errors.theme = 'Le thème est requis';
    if (!formData.type) errors.type = 'Le type est requis';
    if (!formData.orateur) errors.orateur = "L'orateur est requis";
    if (!formData.nb_homme && formData.nb_homme !== 0) errors.nb_homme = 'Le nombre d\'hommes est requis';
    else if (isNaN(formData.nb_homme) || parseInt(formData.nb_homme) < 0) {
      errors.nb_homme = 'Valeur invalide';
    }
    if (!formData.nb_femme && formData.nb_femme !== 0) errors.nb_femme = 'Le nombre de femmes est requis';
    else if (isNaN(formData.nb_femme) || parseInt(formData.nb_femme) < 0) {
      errors.nb_femme = 'Valeur invalide';
    }
    if (!formData.nb_enfant && formData.nb_enfant !== 0) errors.nb_enfant = "Le nombre d'enfants est requis";
    else if (isNaN(formData.nb_enfant) || parseInt(formData.nb_enfant) < 0) {
      errors.nb_enfant = 'Valeur invalide';
    }
    if (!formData.date_at) errors.date_at = 'La date est requise';
    if (!formData.matri_eglise) errors.matri_eglise = "L'église est requise";
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setSaving(true);
    setError(null);
    
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;
      
      // Générer un matricule
      const date = new Date();
      const random = Math.floor(Math.random() * 10000);
      const matricule = `ASS${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}${random}`;
      
      const url = `https://josephsbusiness.com/api/assistances.php?user_id=${userId}`;
      const method = id ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          id: id,
          matricule: matricule,
          nb_homme: parseInt(formData.nb_homme),
          nb_femme: parseInt(formData.nb_femme),
          nb_enfant: parseInt(formData.nb_enfant)
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/evenements/assistances?reload=1');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const totalParticipants = (parseInt(formData.nb_homme) || 0) + 
                           (parseInt(formData.nb_femme) || 0) + 
                           (parseInt(formData.nb_enfant) || 0);

  // ===== Écran de chargement =====
  if (loading) {
    return (
      <>
        <Header />
        <div
          className="main main-app p-3 p-lg-4 d-flex justify-content-center align-items-center"
          style={{
            minHeight: 'calc(100vh - 140px)',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)'
          }}
        >
          <div className="text-center" style={{ maxWidth: '420px', padding: '2rem' }}>
            <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem', color: COLORS.primary }} />
            <h5 className="fw-bold mt-3" style={{ color: COLORS.primaryDark }}>
              Chargement de l'assistance
            </h5>
            <p className="text-muted small">Préparation du formulaire...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // ===== Rendu principal =====
  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
        <div className="container-fluid px-0 px-lg-3">

          {/* ===== EN-TÊTE MODERNE (comme AjouterEglise) ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier une assistance' : 'Nouvelle assistance'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i> {id ? 'Modification' : 'Nouveau'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-time-line"></i> {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/evenements/assistances')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== MESSAGES DE STATUT ===== */}
          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Assistance enregistrée avec succès. Redirection...</p>
              </div>
            </div>
          )}

          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== FORMULAIRE (carte moderne) ===== */}
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> 
                  {id ? 'Modifier les informations' : 'Informations de l\'assistance'}
                </Card.Header>
                <Card.Body className="card-body-modern">
                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={12}>
                        <Form.Group controlId="theme">
                          <Form.Label className="form-label-modern">
                            Thème <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="theme"
                            value={formData.theme}
                            onChange={handleInputChange}
                            placeholder="Ex: Culte d'adoration"
                            isInvalid={!!validationErrors.theme}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.theme}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="type">
                          <Form.Label className="form-label-modern">
                            Type <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="type"
                            value={formData.type}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.type}
                            className="form-select-modern"
                          >
                            <option value="">Sélectionnez un type</option>
                            <option value="culte">Culte</option>
                            <option value="reunion">Réunion</option>
                            <option value="enseignement">Enseignement</option>
                            <option value="priere">Prière</option>
                            <option value="jeune">Jeûne</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{validationErrors.type}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="orateur">
                          <Form.Label className="form-label-modern">
                            Orateur <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="orateur"
                            value={formData.orateur}
                            onChange={handleInputChange}
                            placeholder="Ex: Pasteur Jean"
                            isInvalid={!!validationErrors.orateur}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.orateur}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="nb_homme">
                          <Form.Label className="form-label-modern">
                            Hommes <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="nb_homme"
                            value={formData.nb_homme}
                            onChange={handleInputChange}
                            placeholder="0"
                            min="0"
                            isInvalid={!!validationErrors.nb_homme}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.nb_homme}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="nb_femme">
                          <Form.Label className="form-label-modern">
                            Femmes <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="nb_femme"
                            value={formData.nb_femme}
                            onChange={handleInputChange}
                            placeholder="0"
                            min="0"
                            isInvalid={!!validationErrors.nb_femme}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.nb_femme}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="nb_enfant">
                          <Form.Label className="form-label-modern">
                            Enfants <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="nb_enfant"
                            value={formData.nb_enfant}
                            onChange={handleInputChange}
                            placeholder="0"
                            min="0"
                            isInvalid={!!validationErrors.nb_enfant}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.nb_enfant}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Total participants */}
                      {totalParticipants > 0 && (
                        <Col md={12}>
                          <div className="p-3 text-center" style={{
                            background: `linear-gradient(135deg, ${COLORS.primary}10, ${COLORS.purple}10)`,
                            borderRadius: '4px',
                            border: `1px solid ${COLORS.primary}20`
                          }}>
                            <span className="text-muted me-2">Total participants :</span>
                            <span className="fw-bold fs-4" style={{ color: COLORS.primary }}>{totalParticipants}</span>
                          </div>
                        </Col>
                      )}

                      <Col md={6}>
                        <Form.Group controlId="date_at">
                          <Form.Label className="form-label-modern">
                            Date <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_at"
                            value={formData.date_at}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.date_at}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.date_at}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="matri_eglise">
                          <Form.Label className="form-label-modern">
                            Église <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="matri_eglise"
                            value={formData.matri_eglise}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.matri_eglise}
                            className="form-select-modern"
                          >
                            <option value="">Sélectionnez une église</option>
                            {eglises.map(eglise => (
                              <option key={eglise.matricule} value={eglise.matricule}>
                                {eglise.nom}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{validationErrors.matri_eglise}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Boutons */}
                    <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                      <Button
                        variant="light"
                        size="sm"
                        className="btn-modern-outline"
                        onClick={() => navigate('/evenements/assistances')}
                        disabled={saving}
                      >
                        Annuler
                      </Button>
                      <Button
                        type="submit"
                        size="sm"
                        className="btn-modern-primary"
                        disabled={saving}
                      >
                        {saving ? (
                          <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                        ) : (
                          <><i className="ri-save-line me-1"></i> {id ? 'Modifier' : 'Enregistrer'}</>
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>

      {/* ===== STYLES (identiques à AjouterEglise) ===== */}
      <style>{`
        .fade-in {
          animation: fadeIn 0.3s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .header-modern {
          background: white;
          padding: 1.2rem 1.8rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          border-left: 4px solid ${COLORS.secondary};
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        .header-icon-wrapper {
          width: 48px;
          height: 48px;
          background: ${COLORS.primary};
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          color: white;
          font-size: 1.4rem;
        }
        .gradient-text {
          color: #1e293b;
          font-size: 1.3rem;
          font-weight: 700;
          margin: 0;
        }
        .badge-modern {
          background: #f1f4f9;
          color: #475569;
          padding: 0.3rem 0.8rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .badge-modern i {
          color: ${COLORS.secondary};
        }
        .btn-modern-outline {
          border: 1px solid #d1d5db;
          background: white;
          padding: 0.4rem 1.2rem;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 500;
          color: #4b5563;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .btn-modern-outline:hover {
          border-color: ${COLORS.secondary};
          color: ${COLORS.secondary};
          background: #fafafa;
        }
        .btn-modern-primary {
          background: ${COLORS.primary};
          border: none;
          padding: 0.4rem 1.2rem;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 500;
          color: white;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s;
        }
        .btn-modern-primary:hover {
          background: ${COLORS.primaryDark};
          box-shadow: 0 4px 10px rgba(41,90,167,0.3);
        }
        .btn-modern-primary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .card-modern {
          border: none;
          border-radius: 4px;
          background: white;
          box-shadow: 0 2px 6px rgba(0,0,0,0.04);
          border-top: 3px solid transparent;
          transition: box-shadow 0.2s;
        }
        .card-modern:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
        }
        .card-modern.border-primary {
          border-top-color: ${COLORS.primary};
        }

        .card-header-modern {
          background: transparent;
          border-bottom: 1px solid #e9edf2;
          padding: 0.8rem 1.2rem;
          font-weight: 600;
          color: #1e293b;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .card-header-modern i {
          color: ${COLORS.secondary};
        }

        .card-body-modern {
          padding: 1.5rem;
        }

        .form-label-modern {
          font-size: 0.7rem;
          font-weight: 600;
          color: #475569;
          margin-bottom: 0.2rem;
        }
        .form-label-modern .required {
          color: ${COLORS.danger};
          margin-left: 2px;
        }

        .form-control-modern, .form-select-modern {
          border: 1px solid #e2e8f0;
          border-radius: 4px;
          padding: 0.4rem 0.7rem;
          font-size: 0.85rem;
          transition: all 0.2s ease;
          background: white;
        }
        .form-control-modern:focus, .form-select-modern:focus {
          border-color: ${COLORS.primary};
          box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
        }
        .form-control-modern.is-invalid, .form-select-modern.is-invalid {
          border-color: ${COLORS.danger};
        }
        .form-control-modern.is-invalid:focus, .form-select-modern.is-invalid:focus {
          box-shadow: 0 0 0 3px rgba(239,68,68,0.08);
        }

        .toast-notification {
          padding: 0.8rem 1rem;
          border: none;
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 1.5rem;
          animation: slideDown 0.3s ease-out;
          border-radius: 4px;
        }
        .toast-notification-success {
          background: #f0fdf4;
          border-left: 3px solid ${COLORS.success};
        }
        .toast-notification-error {
          background: #fef2f2;
          border-left: 3px solid ${COLORS.danger};
        }
        .toast-icon {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 1rem;
        }
        .toast-icon-success {
          background: rgba(16,185,129,0.15);
          color: ${COLORS.success};
        }
        .toast-icon-error {
          background: rgba(239,68,68,0.15);
          color: ${COLORS.danger};
        }
        .toast-content {
          flex: 1;
        }
        .toast-title {
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 1px;
        }
        .toast-message {
          font-size: 0.75rem;
          color: #64748b;
          margin: 0;
        }
        .toast-close {
          background: none;
          border: none;
          color: #94a3b8;
          cursor: pointer;
          padding: 2px;
          font-size: 1rem;
        }

        .border-top {
          border-top: 1px solid #e9edf2 !important;
        }

        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .header-modern {
            flex-direction: column;
            align-items: stretch;
            gap: 0.8rem;
            padding: 1rem;
          }
          .header-left {
            flex-wrap: wrap;
          }
          .card-body-modern {
            padding: 1rem;
          }
        }
      `}</style>
    </>
  );
}